import { render, staticRenderFns } from "./HeaderChallengeDisplay.vue?vue&type=template&id=61718331&scoped=true&"
import script from "./HeaderChallengeDisplay.vue?vue&type=script&lang=js&"
export * from "./HeaderChallengeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./HeaderChallengeDisplay.vue?vue&type=style&index=0&id=61718331&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61718331",
  null
  
)

export default component.exports